module.exports = __webpack_public_path__ + "img/add.aed98fcc.svg";